export default function getTermsUrl(proposalId: string, type: string): string {
  return `${process.env.REACT_APP_URL}/proposals/document-view/${proposalId}/${type}`;
}
